import { render, staticRenderFns } from "./ServiceVehicleCustomerViewInformation.vue?vue&type=template&id=64a45164&"
import script from "./ServiceVehicleCustomerViewInformation.vue?vue&type=script&lang=js&"
export * from "./ServiceVehicleCustomerViewInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports